import { createFileRoute, redirect } from "@tanstack/react-router";
import { validateInsightsSearch } from "@/app/partner/pages/dashboard/PartnerInsights/state";
import { TopCountriesPage } from "@/app/partner/pages/dashboard/PartnerInsights/TopCountriesPage";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/insights/countries")({
	validateSearch: validateInsightsSearch,
	beforeLoad: async ({ context }) => {
		if (!canAccessRoute(context.partner, "dashboard").allowed) {
			throw redirect({ to: "/flex/dashboard/leads" });
		}
	},
	component: TopCountriesPage,
});
